import React, {useEffect} from 'react';
import { styled } from "styled-components";
import { getLocale, saveLocale } from "../../i18nInit";
import { t } from 'ttag';

const Select = styled.select`
  background: #F5F5F5;
  border: 0px solid;
  border-radius: 7px;
  margin-right: 10px;
  padding-left: 10px;
  padding-right: 10px;
  height: 38px;
  color: #6F6F6F;
`;

const Form = styled.form`
    background: #F5F5F5;
    border: 0px solid;
    border-radius: 7px;
    margin-right: 10px;
    height: 38px;
`;

const LangSwitcher = () => {
  const defaultLocale = getLocale();

  const detectAndSetLocale = () => {
    const browserLang = navigator.language || navigator.userLanguage;
    const supportedLanguages = ['en', 'es', 'hi'];

    const browserLangShort = browserLang.slice(0, 2);

    if (!defaultLocale && supportedLanguages.includes(browserLangShort)) {
      saveLocale(browserLangShort);
      window.location.reload();
    }
  };

  useEffect(() => {
    detectAndSetLocale();
  }, []);

  const handleChange = (event) => {
    saveLocale(event.target.value);
    window.location.reload();
  };

  return (
    <Form>
      <Select onChange={handleChange} defaultValue={getLocale()}>
        <option value="en">{t`English`}</option>
        <option value="es">{t`Spanish`}</option>
        <option value="hi">{t`Hindi`}</option>
      </Select>
    </Form>
  );
};

export default LangSwitcher;
